/* eslint-disable react/no-unused-state */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { merge } from 'lodash';
import { ContentZonesService, LocaleService, UrlService, ConfigsModel } from '@sm360/widget-commons-core-services';
import { Translations as GeneralTranslations } from '@sm360/widget-commons-general';
import { Translations as FormTranslations } from '@sm360/widget-commons-forms';
import { ORGANIZATIONS } from '@sm360/widget-commons-vehicle';
import config from 'trade-in/config/index.js';

import en from 'trade-in/i18n/en.json';
import fr from 'trade-in/i18n/fr.json';

import InstantEstimate from 'trade-in/components/InstantEstimate/InstantEstimate.jsx';
import { NewTradeInProvider } from './NewTradeInContext';

class InstantEstimateProvider extends Component {
    constructor(props) {
        super(props);
        merge(en, FormTranslations.en, GeneralTranslations.en);
        merge(fr, FormTranslations.fr, GeneralTranslations.fr);

        LocaleService.setLocale(props.locale);
        LocaleService.loadTranslations({ en, fr });

        this.configsModel = new ConfigsModel({
            organizationId: props.organizationId,
            organizationUnitId: props.organizationUnitId,
            organizationUnitLocation: props.organizationUnitLocation,
            websiteId: props.websiteId,
            location: props.location,
            organizationUnitName: props.organizationUnitName,
            organizationUnitPhone: props.organizationUnitPhone,
            schedule_monday: props.schedule_monday,
            schedule_tuesday: props.schedule_tuesday,
            schedule_wednesday: props.schedule_wednesday,
            schedule_thursday: props.schedule_thursday,
            schedule_friday: props.schedule_friday,
            schedule_saturday: props.schedule_saturday,
            schedule_sunday: props.schedule_sunday,
            salesDepartments: props.salesDepartments,
            websiteLogo: props.websiteLogo,
            websiteDomain: props.websiteDomain,
            websiteFacebookPageUrl: props.websiteFacebookPageUrl,
            websiteInstagramClientId: props.websiteInstagramClientId,
            websiteInstagramUserId: props.websiteInstagramUserId,
            websiteTwitterUrl: props.websiteTwitterUrl,
            websiteYoutubeUrl: props.websiteYoutubeUrl,
        });

        ContentZonesService.setImageServerBaseUrl(config.source.image);
        ContentZonesService.addContentZones(this.props.contentZones);

        this.state = {
            fieldsLocked: false,
            setFieldsLocked: this.setFieldsLocked,
            displayNewTradeIn:
                (UrlService.getUrlParameter('newTradeIn') && UrlService.getUrlParameter('newTradeIn') === 'true') ||
                this.props.organizationId === ORGANIZATIONS.DILAWRI,
        };
    }

    setFieldsLocked = (locked) => {
        this.setState({ fieldsLocked: locked });
    };

    render() {
        return (
            // TODO: newTradeIn - Remove NewTradeInProvider after new tradeIn deploy to the PROD
            <NewTradeInProvider value={this.state}>
                <InstantEstimate
                    parentElementId={this.props.parentElementId || this.configsModel.getLocation()}
                    isShowroomV2Enabled={this.props.isShowroomV2Enabled}
                    config={this.configsModel.getConfig()}
                />
            </NewTradeInProvider>
        );
    }
}

InstantEstimateProvider.displayName = 'InstantEstimateProvider';

InstantEstimateProvider.propTypes = {
    locale: PropTypes.string.isRequired,
    location: PropTypes.string.isRequired,
    websiteId: PropTypes.number.isRequired,
    organizationUnitId: PropTypes.number.isRequired,
    organizationId: PropTypes.number.isRequired,
    organizationUnitLocation: PropTypes.string.isRequired,
    contentZones: PropTypes.objectOf(
        PropTypes.arrayOf(
            PropTypes.shape({
                active: PropTypes.bool,
                group: PropTypes.string,
                id: PropTypes.number,
                location: PropTypes.string,
                position: PropTypes.number,
                type: PropTypes.string,
                value: PropTypes.string,
            })
        )
    ).isRequired,
    isShowroomV2Enabled: PropTypes.bool.isRequired,
};

export default InstantEstimateProvider;
